<template>
  <div>
    <div v-if="order.card">
      <h5>Карта к заказу:</h5>
      <p>Номер карты: {{ order.card.card_number }}</p>
      <p>Дата карты: {{ order.card.exp }}</p>
      <p>Номер телефона: {{ order.card.phone }}</p>
    </div>
    <cards :card="order.card" :id="order.client.id" v-model="order.card_id" @input="changeCard" />
    <br />
    <br/>
        <p class="text-danger" v-if="info">{{info}}</p>    
    <br/>
    <div class="install-control">
      <button @click="next" class="btn btn-success">{{ 'next_step' | setText('Далее') }}</button>
    </div>
  </div>
</template>
<script>

import Cards from '@/components/Item/Order/Client/Cards';
import { isArray } from 'util';
import { logger } from '../../../plugins/functions';

export default {
  components: {
    Cards
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
        partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {
      },
    },
    index: {
      default: 0
    }
  },
  name: "filter",
  async created() {

  },
  methods: {
    changeCard(val) {
      this.updateOrder({ card_id: val });
    },
    next() {
      this.save();
    },
    prev() {
      this.$emit('next', this.index - 1);
    },
    save() {

      this.info = null;

      logger(this.$http,{
          name:'Добавление пластиковой карты пользователя в #PAYMART', 
          description: 'Начало запроса',
          model_type:'order',
          model_id : this.order.id
      });
      
      if (!this.order.card) {
        this.$notify({
          title: "PAYMART",
          message: 'Установаите карту',
          icon: "ti-save",
          horizontalAlign: "right",
          verticalAlign: "top",
        });

        logger(this.$http,{
            name:'Добавление пластиковой карты пользователя в #PAYMART', 
            description: 'Оператор не добавил карту. Необходимо повторить',
            model_type:'order',
            model_id : this.order.id
         });
        return false;
      }

      this.$loading(true);
      this.$http
        .post(`${this.partner['endpoint_url']}buyer/send-sms-code-uz`,
          {
            phone: this.order.card.phone,
            card: this.order.card.card_number,
            exp: this.order.card.exp,
          },
          {
            headers: {
              'Authorization': `Bearer ${this.partner['api_secret_key']}`,
              'Content-Type': 'application/json'
            }
          })
        .then((response) => {
   
          if (response.data) {
            switch (response.data.status) {
              case 'success':
                this.message = 'Успешно получили токен';
                this.$emit('getHash', response.data.hash);

                setTimeout(() => {
                  this.$emit('next', 5);
                }, 10);
                break;
              default:
                const info = response.data.info;
                this.info = info;
           
                if (info == 'error_card_equal') {
                  this.message = 'Карта уже зарегистрирована в PAYMART';
                }
                else if (info == 'error_phone_card_equals') {
                  this.message = 'Указанный номер телефона владельца карты не соответсвует';
                }
                else if (info == 'error_card_sms_off') {
                  this.message = 'Не поддключено смс-информирование';
                }
                else if (info == 'error_phone_not_equals') {
                  this.message = 'номер телефона, на который подключена смс инфо карты, не совпадает с номером клиента в системе Paymart';
                }
                else if (info == 'empty_balance') {
                  this.message = 'На карте нет средств';
                }
                else {
                  this.message = 'Карта не проходит по скорингу';
                }
                break;
            }

             logger(this.$http,{
                name:'Добавление пластиковой карты пользователя в #PAYMART', 
                description: this.message,
                model_type:'order',
                model_id : this.order.id
             });

          }
          this.$notify({
            title: "PAYMART",
            message: this.message,
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
        })
        .catch(({response}) => {  
          alert('Карта не проходит');

          logger(this.$http,{
            name:'Добавление пластиковой карты пользователя в #PAYMART', 
            description: 'Ошибка системы #PAYMART',
            model_type:'order',
            model_id : this.order.id
         });
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: '',
      info:null
    };
  },
};
</script>
<style lang="scss">
</style>
